<template>
<b-row>
  <b-col class="col-xxl-6">
    <b-card>
      <div class="d-flex justify-content-between" >
        <div class="d-flex flex-column justify-content-between">
          <div class="header-1">{{dashboard.clientCount}}</div>
          <div class="header-2">Broj klijenata fonda</div>
        </div>
        <i class="icon-home fa-fw large-icon" aria-hidden="true"></i>
      </div>
    </b-card>
  </b-col>
  <b-col class="col-xxl-6">
    <b-card>
      <div class="d-flex justify-content-between" >
        <div class="d-flex flex-column justify-content-between">
          <div class="header-1">{{ dashboard.clientPhysicalPerson }}</div>
          <div class="header-2">Broj fizičkih lica</div>
        </div>
        <i class="fa fa-users  fa-fw large-icon" aria-hidden="true"></i>
      </div>
    </b-card>
  </b-col>
  <b-col class="col-xxl-6">
    <b-card>
      <div class="d-flex justify-content-between" >
        <div class="d-flex flex-column justify-content-between">
          <div class="header-1">{{ dashboard.clientLegalEntity }}</div>
          <div class="header-2">Broj pravnih lica</div>
        </div>
        <i class="fa fa-building fa-fw large-icon" aria-hidden="true"></i>
      </div>
    </b-card>
  </b-col>
  <b-col class="col-xxl-6">
    <b-card>
      <div class="d-flex justify-content-between" >
        <div class="d-flex flex-column justify-content-between">
          <div class="header-1">{{ dashboard.nvi | formatDecimals(4)}} (KM)</div>
          <div class="header-2">NVI</div>
        </div>
        <i class="fa fa-line-chart fa-fw large-icon" aria-hidden="true"></i>
      </div>
    </b-card>
  </b-col>
</b-row>
</template>

<script>
import {mapGetters} from "vuex";
import {USER_DATA} from "@/shared/constants";
import {getDashboardData} from "@/services/client";
import { formatDecimals } from "@/filters/formatDates";

export default {
  name: 'AdminDashboard',
  data() {
    return {
      dashboard: {
        clientCount: null,
        clientLegalEntity: null,
        clientPhysicalPerson: null,
        nvi: null
      }
    }
  },
  filters: {
    formatDecimals
  },
  computed: {
    ...mapGetters('client', ['client']),
    user(){
      return JSON.parse(localStorage.getItem(USER_DATA))
    }
  },
  async mounted() {
    getDashboardData().then((response) => {
      this.dashboard = response.data
    })
  }
};
</script>

<style scoped>
.large-icon {
  font-size: 46px;
  line-height: 1.2;
  color: #e94f4f
}
</style>
